var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBlockMessages = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.998,
    viewBox: "0 0 18 17.998",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BlockMessages",
    transform: "translate(-240.025 -276.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_19",
    "data-name": "Subtraction 19",
    d: "M23350.9,19484.953a.313.313,0,0,1-.137-.033c-.162-.074-.176-.223-.176-.393v-4.193h-2.539a2.036,2.036,0,0,1-2.023-2.062c-.006-3.068-.006-6.18,0-9.242a2.065,2.065,0,0,1,2.064-2.074h13.832a2.032,2.032,0,0,1,1.936,1.271,1.967,1.967,0,0,1,.115.338l0,.016c.012.041.023.08.037.121l.008.029v9.8l-.008.018c-.008.018-.016.035-.021.053a2.042,2.042,0,0,1-2.135,1.723h-.783l-.648,0h-1.111c-.646,0-1.449,0-2.547-.008a.751.751,0,0,0-.51.2c-1.984,1.684-3.592,3.047-5.061,4.291A.472.472,0,0,1,23350.9,19484.953Zm4.125-16a5,5,0,1,0,5,5,5.045,5.045,0,0,0-5-5Zm0,8.531a3.527,3.527,0,0,1-2.879-5.576l4.92,4.92A3.456,3.456,0,0,1,23355.029,19477.484Zm2.869-1.482v0l-4.914-4.918a3.438,3.438,0,0,1,2.045-.656,3.532,3.532,0,0,1,3.525,3.529,3.464,3.464,0,0,1-.656,2.045Z",
    transform: "translate(-23106 -19190)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBlockMessages);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_block_messages.737a9effab35e8fa7da91269ddae9a26.svg";